import { Controller } from "remult";

@Controller("volunteer-organization-lead-methods")
export class VolunteerOrganizationLeadMethods {}
